import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './DueDate.css';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import withContext from "../../../withContext";

const service = new Service();

class DuedateFaqs extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        this.state = {

            loggedin: false,
            IsExpected: false,
            isApp: false

        }
    }
    componentDidMount() {
        console.log("componentdidMount=============>");
        if (this.props.location.search.includes('from=app')) {
            this.setState({ isApp: true });
        }
    }
    duDateQans(id) {
        if (document.getElementById(id).firstElementChild.nextSibling.style.display != "none") {
            document.getElementById(id).firstElementChild.style.marginBottom = "10px"
            document.getElementById(id).nextSibling.style.display = "block";
            document.getElementById(id).firstElementChild.nextSibling.style.display = "none";
            document.getElementById(id).firstElementChild.nextSibling.nextSibling.style.display = "block";
        } else {
            document.getElementById(id).firstElementChild.style.marginBottom = "0px"
            document.getElementById(id).nextSibling.style.display = "none";
            document.getElementById(id).firstElementChild.nextSibling.style.display = "block";
            document.getElementById(id).firstElementChild.nextSibling.nextSibling.style.display = "none";
        }
    }
    render() {
        return (
            <main className="main-container">
                <Helmet
                    title="FAQs | Due Date Calculator"
                    meta={[
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                     {!this.state.isApp &&
                        <div className="breadcrumb R11_9e">
                            <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span>Due Date Calculator</span>
                        </div>
                    }
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>Due Date Calculator </h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="duedate-container">
                            {/* <!-- duedate faqs code starts here --> */}
                            <div className="duedate-faq" id="">
                                <div className="duedate-question" id="faq1" onClick={() => { this.duDateQans("faq1") }}>
                                    <h2 id="faq1">
                                        <span className="M17_42" id="faq1">
                                            <span className="M17_9e" id="faq1">Q. </span>
                                            How is my due date calculated?
                                        </span>
                                    </h2>
                                    <span className="arrow-down icon" data-icon-font="f"></span>
                                    <span className="arrow-up icon" data-icon-font="n"></span>
                                </div>
                                <div className="duedate-answer">
                                    <span className="R15_42">
                                        A.
                                        Naegele's Rule is considered the gold standard of calculating the due date for a pregnancy. According to the rule, the expected date of delivery (EDD) is calculated by adding a year, subtracting three months, and adding seven days to the first day of a woman's last menstrual period (LMP).
                                    </span>
                                </div>
                            </div>
                            <div className="duedate-faq" id="">
                                <div className="duedate-question" id="faq2" onClick={() => { this.duDateQans("faq2") }}>
                                    <h2 id="faq2">
                                        <span className="M17_42" id="faq2">
                                            <span className="M17_9e" id="faq2">Q. </span>How accurate are these due dates?
                                        </span>
                                    </h2>
                                    <span className="arrow-down icon" data-icon-font="f"></span>
                                    <span className="arrow-up icon" data-icon-font="n"></span>
                                </div>
                                <div className="duedate-answer">
                                    <span className="R15_42">
                                        A. No method can predict the due date of your baby with 100% certainty! Only Only about 5% of all babies are actually born on their estimated date of birth! This is mostly owing to the fact that a pregnancy can last anywhere between 38 and 42 weeks: so your baby may be born anywhere between 2 weeks before and 2 weeks after your estimated due date.
                                    </span>
                                </div>
                            </div>
                            <div className="duedate-faq" id="">
                                <div className="duedate-question" id="faq3" onClick={() => { this.duDateQans("faq3") }}>
                                    <h2 id="faq3">
                                        <span className="M17_42" id="faq3">
                                            <span className="M17_9e" id="faq3">Q. </span>
                                            When should I first see the doctor?
                                        </span>
                                    </h2>
                                    <span className="arrow-down icon" data-icon-font="f"></span>
                                    <span className="arrow-up icon" data-icon-font="n"></span>
                                </div>
                                <div className="duedate-answer">
                                    <span className="R15_42">
                                        A. 
                                        Good prenatal care is strongly advised in ensuring a healthy pregnancy and baby. In other words, it’s never too early! Ideally you should consult a doctor before you start trying to get pregnant, and followup through your pregnancy till your baby is born. At the very latest, you should see your doctor as soon as that home pregnancy test kit tells you - you are pregnant!
                                    </span>
                                </div>
                            </div>
                            <div className="duedate-faq" id="">
                                <div className="duedate-question" id="faq4" onClick={() => { this.duDateQans("faq4") }}>
                                    <h2 id="faq4">
                                        <span className="M17_42" id="faq4">
                                            <span className="M17_9e" id="faq4">Q. </span>
                                            Can my due date change?
                                        </span>
                                    </h2>
                                    <span className="arrow-down icon" data-icon-font="f"></span>
                                    <span className="arrow-up icon" data-icon-font="n"></span>
                                </div>
                                <div className="duedate-answer">
                                    <span className="R15_42">
                                        A. 
                                        There is a set formula used to calculate your estimated due date – any doctor using the same formula will give you the same EDD. However, when your baby actually arrives may be anywhere between 2 weeks before and after your EDD. Having said that, your doctor may recalibrate your EDD depending on how your pregnancy progresses.
                                    </span>
                                </div>
                            </div>
                            <div className="duedate-faq" id="">
                                <div className="duedate-question" id="faq5" onClick={() => { this.duDateQans("faq5") }}>
                                    <h2 id="faq5">
                                        <span className="M17_42" id="faq5">
                                            <span className="M17_9e" id="faq5">Q. </span>
                                            How else is my due date calculated?
                                        </span>
                                    </h2>
                                    <span className="arrow-down icon" data-icon-font="f"></span>
                                    <span className="arrow-up icon" data-icon-font="n"></span>
                                </div>
                                <div className="duedate-answer">
                                    <span className="R15_42">
                                        A. 
                                        Apart from Naegele's Rule previously explained, the following methods can be used to estimate your date of conception and estimated due date: Size of your uterus: An early ultrasound (which your doctor may or may not recommend, depending on your particular case).Pregnancy milestones such as the first foetal heartbeat (usually seen at about 9 weeks of pregnancy), first time you feel foetal movement (roughly around 16 weeks), etc.  The fundal height: when the fundus reaches your navel, you are about 20 weeks into your pregnancy
                                    </span>
                                </div>
                            </div>
                            <div className="duedate-faq" id="">
                                <div className="duedate-question" id="faq6" onClick={() => { this.duDateQans("faq6") }}>
                                    <h2 id="faq6">
                                        <span className="M17_42" id="faq6">
                                            <span className="M17_9e" id="faq6">Q. </span>
                                            What are the other methods of calculating due dates?
                                        </span>
                                    </h2>
                                    <span className="arrow-down icon" data-icon-font="f"></span>
                                    <span className="arrow-up icon" data-icon-font="n"></span>
                                </div>
                                <div className="duedate-answer">
                                    <span className="R15_42">
                                        A. Several other methods can be employed to calculate due date: An ultrasound scan.Clinical examination of pelvis (assessed alongside correct information about your menstrual cycle). Doppler ultrasonography (which can be used after 10 to 12 weeks of pregnancy). Human Chorionic Gonadotropin (hCG) Pregnancy Test.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(DuedateFaqs);
